import React from 'react';

import { SiteFooter } from '../../components/SiteFooter/SiteFooter';
// Gallery carousel temporarily hidden — kept for re-enable.
// import { CareersGallerySection } from './CareersGallerySection';
import { CareersHeroSection } from './CareersHeroSection';
import { CareersPitchSection } from './CareersPitchSection';
import { CareersRolesSection } from './CareersRolesSection';
import type { CareersPageData } from './types';

export function CareersPage({ csrfToken, hero, pitch, roles }: CareersPageData) {
    return (
        <div className="careers-page">
            <main className="careers-page__main">
                <CareersHeroSection data={hero} />
                <CareersPitchSection data={pitch} />
                {/* Gallery carousel temporarily hidden — restore <CareersGallerySection data={gallery} /> to re-enable. */}
                <CareersRolesSection data={roles} />
            </main>
            <SiteFooter csrfToken={csrfToken} />
        </div>
    );
}
